import React, { useContext, useEffect, useState } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import Skeleton from 'react-loading-skeleton'
import handleNotification from 'utils/toast/handleNotification'
import WORDING from 'constants/wording'
import { ZENDESK_URL } from 'config'
import { getCreditLines } from 'api/credit-score'
import CardButton from 'components/CardButtons'
import HubInformationModal from 'components/HubInformationModal'
import {
  advanceIsDisabled,
  hasActiveMembership
} from 'utils/membershipFunction'
import format from 'date-fns/format'
// import { UserContext } from 'contexts/user'
// import { URL_RENOVADOR } from 'config'
// import { InformationIcon } from 'assets/icons'
import { useNavigate } from 'react-router-dom'
import PrimaryButton from '../../components/primaryButton'
import Table from '../../components/table'
import TableItem from '../../components/TableItem'
import { tableItemButton } from '../../constants/tableItem'
import useShare from '../../hooks/useShare'
import { MeContext } from '../../contexts/me'
import PageWrapper from '../../components/PageWrapper'
// import MoneyBag from '../../assets/images/money-bag.png'
import Thunderbolt from '../../assets/images/emojis/thunderbolt.png'

export default function Money() {
  const [bankData, setBankData] = useState()

  const navigate = useNavigate()

  const { successToast } = handleNotification()
  const { handleShare, showButtonCopy, setShareData } = useShare()

  const { me } = useContext(MeContext)
  // const { user } = useContext(UserContext)

  const { COPIADO, CVU, ALIAS } = WORDING

  const texts = {
    cvu: { label: CVU, value: me?.bank?.internal_account[0].cvu },
    alias: { label: ALIAS, value: me?.bank?.internal_account[0].cvu_alias }
  }

  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_cargar_dinero' })
  }, [])

  useEffect(() => {
    if (me) {
      const { bank } = me
      setBankData(bank)

      setShareData({
        text: `Te comparto mis Wayni datos: Alias: ${texts.alias.value}, Cvu: ${texts.cvu.value}`
      })
    }
  }, [me])

  function onCopyAll() {
    navigator.clipboard
      .writeText(`Alias: ${texts.alias.value}, Cvu: ${texts.cvu.value}`)
      .then(() => {
        successToast(COPIADO)
      })
  }

  function onCopy(text) {
    navigator.clipboard.writeText(text)
    successToast(COPIADO)
  }

  return (
    <PageWrapper noTabBar title='Cargar dinero' viewSelected='/movimientos'>
      <div className='md:max-w-564 h-full my-0 mx-auto bg-color-gray-100 items-center md:pt-[25px]'>
        <p className='text-xs text-black font-medium px-4'>
          Recibís el dinero a tu CVU desde una cuenta bancaria o billetera
          virtual (tuya o de otra persona). Si recibís la transferencia entre
          las 07 y 00 hs,{' '}
          <span className='font-bold'> ¡se acredita al instante!</span>
        </p>
        {bankData ? (
          <Table className='my-6 !px-3 sm:px-6'>
            <TableItem
              label='CVU'
              value={bankData.internal_account[0].cvu}
              valueClassName='text-[0.938rem] sm:text-base'
              buttonType={tableItemButton.COPY}
              onClick={() => onCopy(bankData.internal_account[0].cvu)}
            />
            <TableItem
              label='Alias'
              value={bankData.internal_account[0].cvu_alias}
              valueClassName='text-[0.938rem] sm:text-base'
              buttonType={tableItemButton.COPY}
              onClick={() => onCopy(bankData.internal_account[0].cvu_alias)}
            />
          </Table>
        ) : (
          <div className='w-full my-6'>
            <Skeleton height={50} count={2} />
          </div>
        )}
        {me ? (
          <CardButton
            icon={Thunderbolt}
            title='Adelantos en tu tarjeta'
            description='Hacé click y pateá tus pagos'
            className='mb-4'
            onClick={() => navigate('/wayni-credito')}
          />
        ) : (
          <Skeleton height={90} className='my-4' />
        )}

        <Table>
          {/* eslint-disable-next-line */}
          <a
            href={`${ZENDESK_URL}/requests/new`}
            target='_blank'
            rel='noreferrer'
          >
            <TableItem value='Ayuda' buttonType={tableItemButton.ARROW} />
          </a>
        </Table>
        {/* <div className='flex flex-row w-full items-center gap-2 mt-5 text-2xs font-medium text-purple-900 mx-3'>
            <InformationIcon className='shrink-0' />
            <span>
              Los cajeros automáticos todavía no permiten{' '}
              <br className='md:hidden' /> transferir a un CVU
            </span>
          </div> */}
        <div className='flex w-full mb-12 mt-8 sm:w-40 sm:ml-auto'>
          {showButtonCopy ? (
            <PrimaryButton
              type='button'
              buttonText='Copiar'
              outlined={false}
              primaryButtonFunction={() => onCopyAll()}
            />
          ) : (
            <PrimaryButton
              type='button'
              isDisabled={showButtonCopy}
              buttonText='Compartir'
              outlined={false}
              isShare
              primaryButtonFunction={() => handleShare()}
            />
          )}
        </div>
      </div>
    </PageWrapper>
  )
}
